import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Common } from '../../utils/common';

const $ = window.$;

function AcquisitionDetailTable({ tableData, isAutomotiveIndustry, isTextingEnabled }) {
  const tableEl = useRef();

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      data: tableData,
      dom: '<fB>tlip',
      lengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All'],
      ],
      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        var index = iDisplayIndexFull + 1 + '.';
        $('td:eq(0)', nRow).html(index);
        return nRow;
      },
      columnDefs: [{ className: 'text-center', targets: '_all' }],
      stateSave: true,
      stateSaveCallback: function (oSettings, oData) {
        localStorage.setItem('DataTables-AI-Acquisition_Detail', JSON.stringify(oData));
      },
      stateLoadCallback: function (oSettings) {
        return JSON.parse(localStorage.getItem('DataTables-AI-Acquisition_Detail'));
      },
      buttons: [
        { extend: 'colvis', text: 'Select Columns', columns: ':gt(0)' },
        {
          extend: 'excelHtml5',
          text: 'Data Export',
          title: 'Data-Export',
          exportOptions: {
            columns: function (idx, data, node) {
              const hideFromExport = [0];
              var isVisible = table.column(idx).visible();
              var isNotForExport = $.inArray(idx, hideFromExport) !== -1;
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columns: columnBuilder(isAutomotiveIndustry, isTextingEnabled),
      destroy: true,
      footerCallback: function () {
        var api = this.api();
        const columnLength = api.columns().toArray()[0].length;
        for (let i = 7; i < columnLength; i++) {
          const sum = api
            .column(i)
            .data()
            .reduce((a, b) => a + b, 0);
          $(api.column(i).footer()).html(Common.formatNumberWithCommas(sum));
        }
      },
    });

    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
    };
  }, [tableData, isAutomotiveIndustry, isTextingEnabled]);

  return (
    <div className='table-responsive' style={{ paddingBottom: '30px' }}>
      <table
        ref={tableEl}
        className='table table-hover table-striped vertical_centered table-bordered'
        style={{ width: '100%' }}
      >
        <thead>
          <tr>
            <th rowSpan={2} colSpan={1}></th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Referrer
            </th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Source
            </th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Medium
            </th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Campaign
            </th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Content
            </th>
            <th className='table_cell_centered_text' rowSpan={2} colSpan={1}>
              Keyword
            </th>
            <th className='table_cell_centered_text' rowSpan={1} colSpan={1}>
              Acquisition
            </th>
            <th className='table_cell_centered_text' rowSpan={1} colSpan={9}>
              Conversions
            </th>
          </tr>
          <tr>
            <th>Total Visitors</th>
            {isTextingEnabled ? <th>Total Texts</th> : null}
            <th>Total WebForms</th>
            <th>Total Chats</th>
            <th>Total Calls</th>
            {isAutomotiveIndustry ? (
              <>
                <th>Sales</th>
                <th>Service</th>
                <th>Parts</th>
                <th>Sales Appts</th>
                <th>No Appts</th>
              </>
            ) : null}
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th style={{ textAlign: 'right' }} colSpan={7}>
              Total:
            </th>
            <th></th>
            {isTextingEnabled ? <th></th> : null}
            <th></th>
            <th></th>
            <th></th>
            {isAutomotiveIndustry ? (
              <>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </>
            ) : null}
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

function columnBuilder(isAutomotiveIndustry, isTextingEnabled) {
  const columns = [];

  columns.push({
    data: null,
    render: () => '&nbsp;',
    searchable: false,
    orderable: false,
  });
  columns.push({ data: 'ref_domain' });
  columns.push({ data: 'utm_source' });
  columns.push({ data: 'utm_medium' });
  columns.push({ data: 'utm_campaign' });
  columns.push({ data: 'utm_content' });
  columns.push({ data: 'utm_term' });
  columns.push({ data: 'visitors', render: $.fn.dataTable.render.number(',') });

  if (isTextingEnabled) {
    columns.push({ data: 'texts', render: $.fn.dataTable.render.number(',') });
  }

  columns.push({ data: 'leads', render: $.fn.dataTable.render.number(',') });
  columns.push({ data: 'chats', render: $.fn.dataTable.render.number(',') });
  columns.push({ data: 'calls', render: $.fn.dataTable.render.number(',') });

  if (isAutomotiveIndustry) {
    columns.push({ data: 'sales', render: $.fn.dataTable.render.number(',') });
    columns.push({ data: 'service', render: $.fn.dataTable.render.number(',') });
    columns.push({ data: 'parts', render: $.fn.dataTable.render.number(',') });
    columns.push({ data: 'appts', render: $.fn.dataTable.render.number(',') });
    columns.push({ data: 'noappts', render: $.fn.dataTable.render.number(',') });
  }

  return columns;
}

AcquisitionDetailTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  isAutomotiveIndustry: PropTypes.bool.isRequired,
  isTextingEnabled: PropTypes.bool.isRequired,
};

export default AcquisitionDetailTable;
